export const companyInfo = {
  name: "Mehra Mac Industries",
  brand: "Mac Wires",
  tagline: "Premium Copper Wires",
  subtitle: "Leading Copper Wire Manufacturer in Hyderabad",
  description: "Powering the world with Mac Wires. Leading manufacturer of Submersible, Bare Copper, and CCR wires in Hyderabad.",
  heroImage: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/1qqly4r0_Factory%20image.png",
  logo: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/nj25yio6_Logo.jpg",
  contacts: {
    unitManager: { label: "Unit Manager", number: "8341019995" },
    sales: { label: "Sales & Solutions", numbers: ["9000999995", "9246523153"] },
  },
  whatsapp: "9000999995",
  email: "ankit@macwires.com",
  address: "Hyderabad, Telangana",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.5858!2d78.4089!3d17.5116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDMwJzQxLjgiTiA3OMKwMjQnMzIuMCJF!5e0!3m2!1sen!2sin!4v1234567890",
};

export const products = [
  {
    id: 1,
    name: "Copper Rods",
    description: "All types of copper rods in CC Grade, Commercial Grade and CCR for diverse applications",
    image: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/emdc8ir7_copper%20rod.png",
    specs: "CC Grade | Commercial Grade | CCR - 8mm",
    features: ["Multiple grade options", "8mm diameter", "Bulk availability"],
    badge: null,
  },
  {
    id: 2,
    name: "CCR Wires",
    description: "Continuous Cast & Rolled copper wires for high-performance applications",
    image: "https://customer-assets.emergentagent.com/job_coppertrade/artifacts/g3yaptqi_CCR.jpg",
    specs: "8mm diameter - Premium quality",
    features: ["High purity copper", "Consistent dimensions", "Superior finish"],
    badge: null,
  },
  {
    id: 3,
    name: "Bare Copper Wires",
    description: "Ultra-thin bare copper wires starting from 0.100mm for the electrical wire industry",
    image: "https://customer-assets.emergentagent.com/job_123ccc04-ace4-4c2b-bc29-2f2fbf9c89dc/artifacts/zq0d3oji_Bare%20Copper%20Wire.png",
    specs: "From 0.100mm upwards - Spools of 1kg to 7kg",
    features: ["Thinnest from 0.100mm", "1-7 kg spools", "For wire industry supply"],
    badge: null,
  },
  {
    id: 4,
    name: "Submersible Wires - PolyMac",
    description: "Premium CC grade poly-wrapped submersible wires for superior performance",
    image: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/bjv3nlpx_PolyMac%20Submersible%20Wire.png",
    specs: "CC Grade (Top Quality) - 0.5mm to 1.5mm",
    features: ["CC Grade purity", "Poly wrapped insulation", "Superior conductivity"],
    badge: "Premium",
  },
  {
    id: 5,
    name: "Submersible Wires - Poly Om & Poly Kiran",
    description: "Commercial grade poly-wrapped submersible wires for cost-effective solutions",
    image: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/x6m45swg_PolyOm%20and%20PolyKiran.png",
    specs: "Commercial Grade - 0.5mm to 1.5mm",
    features: ["Commercial grade", "Reliable performance", "Value for money"],
    badge: "Popular",
  },
  {
    id: 6,
    name: "Earthing Wire",
    description: "High-quality earthing copper wires for electrical safety and grounding systems",
    image: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/qjkok5dd_Earthing%20Wire.png",
    specs: "Various sizes for grounding applications",
    features: ["Superior conductivity", "Corrosion resistant", "Safety certified"],
    badge: null,
  },
  {
    id: 7,
    name: "Annealed Copper Wire",
    description: "Soft annealed copper wire in heavy spools for direct processing or further drawing",
    image: "https://customer-assets.emergentagent.com/job_123ccc04-ace4-4c2b-bc29-2f2fbf9c89dc/artifacts/jfb8lyc2_Annealed%20copper%20wire.png",
    specs: "50-100 kg spools - For processing & drawing",
    features: ["50-100 kg spools", "Direct processing ready", "Further drawing capable"],
    badge: null,
  },
];

export const features = [
  {
    icon: "Zap",
    title: "Quality Manufactured",
    description: "Premium grade copper products manufactured to meet the highest industry standards",
  },
  {
    icon: "Shield",
    title: "Trusted Manufacturer",
    description: "Years of manufacturing excellence serving industries across the region",
  },
  {
    icon: "Award",
    title: "Competitive Pricing",
    description: "Best market rates with flexible payment options for all products",
  },
  {
    icon: "TrendingUp",
    title: "Reliable Supply",
    description: "Consistent production capacity ensuring timely delivery of orders",
  },
];

export const industries = [
  {
    name: "Electrical Wire Manufacturers",
    description: "Premium bare copper wire supply for electrical wire production lines",
    image: "https://customer-assets.emergentagent.com/job_coppertrade/artifacts/vvk8hnbw_Electrical%20wire%20manufacturers.png",
  },
  {
    name: "Submersible Pump Industry",
    description: "PolyMac & Poly Om wires for pump manufacturers and winding services",
    image: "https://customer-assets.emergentagent.com/job_123ccc04-ace4-4c2b-bc29-2f2fbf9c89dc/artifacts/a854ii3i_Submersible%20pump%20industry.png",
  },
  {
    name: "House Wiring Cable Industry",
    description: "Quality bare copper wires for residential and commercial cable manufacturing",
    image: "https://customer-assets.emergentagent.com/job_123ccc04-ace4-4c2b-bc29-2f2fbf9c89dc/artifacts/38sjyrdl_House%20wiring%20industry.png",
  },
  {
    name: "Wire Drawing Units",
    description: "Annealed copper wire and rods for wire drawing and further processing",
    image: "https://customer-assets.emergentagent.com/job_polymac-copper/artifacts/1qqly4r0_Factory%20image.png",
  },
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/#products" },
  { name: "Industries", path: "/#industries" },
  { name: "Contact", path: "/contact" },
];
